import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CommonTable from '../../../../common/table/ComonTable';
import apiServices from '../../../../../services/apiService';
import DeleteModal from '../../../../common/commonmodal/DeleteModal';

const UnitNumberMaster = () => {
    const navigate = useNavigate();
    const [units, setUnits] = useState([]);
    const [loading, setLoading] = useState(false);

    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [recordToDelete, setRecordToDelete] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageInfo, setPageInfo] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1,
        totalRecords: 0
    });

    const fetchTableData = async () => {
        setLoading(true);
        try {
            const currentSiteId = localStorage.getItem('siteId') || 2;
            const response = await apiServices({
                method: "GET",
                url: `/UnitNumberMaster/GetAllUnitNumberMaster?siteId=${currentSiteId}&pageNumber=${currentPage}&pageSize=${pageInfo.pageSize}`
            });

            if (response.success) {
                let apiData = response.data.data || response.Data;
                const total = response.data.TotalCount || apiData.length;
                setUnits(apiData);
                setPageInfo(prev => ({
                    ...prev,
                    totalRecords: total,
                    totalPages: Math.ceil(total / prev.pageSize) || 1
                }));
            }
        } catch (error) {
            console.error("Error fetching unit numbers:", error);
            toast.error("Failed to fetch unit numbers.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTableData();
    }, [currentPage, pageInfo.pageSize]);

    const confirmDelete = async () => {
        if (!recordToDelete) return;
        const idToDelete = recordToDelete.UnitNumberId || recordToDelete.unitNumberId || recordToDelete.Id || recordToDelete.id;
        try {
            const response = await apiServices({
                method: "DELETE",
                url: `/UnitNumberMaster/RemoveExistingUnitNumber/${idToDelete}`
            });

            if (response.success || response.IsSuccess || response.isSuccess) {
                toast.success("Unit Number deleted successfully");
                fetchTableData();
            } else {
                toast.error(response.message || response.Message || "Failed to delete");
            }
        } catch (error) {
            toast.error("An error occurred during deletion");
        } finally {
            setIsDeleteOpen(false);
            setRecordToDelete(null);
        }
    };

    const tableHeaders = [
        { label: "Unit Number", key: "UnitNumber" },
        { label: "Site", key: "SiteName" },
        { label: "Wing", key: "WingName" },
        { label: "Floor", key: "FloorName" },
        { label: "Status", key: "Status" },
        { label: "Actions", key: "actions" }
    ];

    const renderCell = (key, row) => {
        switch (key) {
            case "Status":
                return (
                    <span className={`px-2 py-1 rounded-md text-xs font-bold ${row.Status === 'Occupied' ? 'bg-blue-50 text-blue-700' : 'bg-green-50 text-green-700'
                        }`}>
                        {row.Status || "Available"}
                    </span>
                );
            default:
                return <span className="text-sm text-gray-700 font-medium">{row[key] || "—"}</span>;
        }
    };

    const handleLimitChange = (newLimit) => {
        setPageInfo(prev => ({ ...prev, pageSize: newLimit }));
        setCurrentPage(1);
    };

    return (
        <div className="flex flex-col flex-1 relative min-h-0 pt-4">
            <div className="flex-1 overflow-y-auto">
                <CommonTable
                    headers={tableHeaders}
                    data={units}
                    renderCell={renderCell}
                    isLoading={loading}
                    hideScrollbar={false}
                    pagination={{
                        ...pageInfo,
                        pageNumber: currentPage
                    }}
                    onPageChange={setCurrentPage}
                    onLimitChange={handleLimitChange}
                    showActionCol={true}
                    onEdit={(row) => {
                        const idToEdit = row.UnitNumberId || row.unitNumberId || row.Id || row.id;
                        navigate(`/zentcomm/site-management/unit-number/form`, { state: { id: idToEdit, record: row } });
                    }}
                    onDelete={(row) => {
                        setRecordToDelete(row);
                        setIsDeleteOpen(true);
                    }}
                />
            </div>

            <DeleteModal
                isOpen={isDeleteOpen}
                onClose={() => setIsDeleteOpen(false)}
                onConfirm={confirmDelete}
                title="Delete Unit Number"
                description={`Are you sure you want to delete unit ${recordToDelete?.UnitNumber}? This action cannot be undone.`}
            />
        </div>
    );
};

export default UnitNumberMaster;
